var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:{
    'btn--mobile': _vm.isMobile,
    'btn--white': _vm.color === 'white'
  },attrs:{"id":_vm.id || _vm.title || undefined,"block":_vm.block,"color":_vm.color,"disabled":_vm.disabled || _vm.loading,"loading":_vm.loading,"depressed":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$te(_vm.title) ? _vm.$t(_vm.title) : _vm.title))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }